import { createTheme } from '@mui/material';

const giftCardConnectionTheme = createTheme({
	typography: {
		fontFamily: 'Work Sans'
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#00BBF2'
		},
		secondary: {
			main: '#CCDB2A'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#0089b1'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const valuePlusTheme = createTheme({
	typography: {
		fontFamily: 'Montserrat'
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#E6E163'
		},
		secondary: {
			main: '#002856'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#01336d'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const savingsCentralTheme = createTheme({
	typography: {
		fontFamily: ['Titillium Web', 'Assistant'].join(','),
		h1: {
			fontFamily: 'Titillium Web'
		},
		h2: {
			fontFamily: 'Titillium Web'
		},
		h3: {
			fontFamily: 'Titillium Web'
		},
		h4: {
			fontFamily: 'Titillium Web'
		},
		h5: {
			fontFamily: 'Titillium Web'
		},
		h6: {
			fontFamily: 'Titillium Web'
		},
		body1: {
			fontFamily: 'Assistant'
		},
		body2: {
			fontFamily: 'Assistant'
		},
		subtitle1: {
			fontFamily: 'Assistant'
		},
		subtitle2: {
			fontFamily: 'Assistant'
		},
		overline: {
			fontFamily: 'Assistant'
		},
		caption: {
			fontFamily: 'Assistant'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#35C9A4'
		},
		secondary: {
			main: '#707274'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#268f74'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const tasteForSavingsTheme = createTheme({
	typography: {
		fontFamily: ['Poppins', 'Nunito'].join(','),
		h1: {
			fontFamily: 'Poppins'
		},
		h2: {
			fontFamily: 'Poppins'
		},
		h3: {
			fontFamily: 'Poppins'
		},
		h4: {
			fontFamily: 'Poppins'
		},
		h5: {
			fontFamily: 'Poppins'
		},
		h6: {
			fontFamily: 'Poppins'
		},
		body1: {
			fontFamily: 'Nunito'
		},
		body2: {
			fontFamily: 'Nunito'
		},
		subtitle1: {
			fontFamily: 'Nunito'
		},
		subtitle2: {
			fontFamily: 'Nunito'
		},
		overline: {
			fontFamily: 'Nunito'
		},
		caption: {
			fontFamily: 'Nunito'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#136F63'
		},
		secondary: {
			main: '#FDE9D8'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#136f63'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const homePlayTheme = createTheme({
	typography: {
		fontFamily: ['Oleo Script', 'Karla'].join(','),
		h1: {
			fontFamily: 'Oleo Script'
		},
		h2: {
			fontFamily: 'Oleo Script'
		},
		h3: {
			fontFamily: 'Oleo Script'
		},
		h4: {
			fontFamily: 'Karla'
		},
		h5: {
			fontFamily: 'Karla'
		},
		h6: {
			fontFamily: 'Karla'
		},
		body1: {
			fontFamily: 'Karla'
		},
		body2: {
			fontFamily: 'Karla'
		},
		subtitle1: {
			fontFamily: 'Karla'
		},
		subtitle2: {
			fontFamily: 'Karla'
		},
		overline: {
			fontFamily: 'Karla'
		},
		caption: {
			fontFamily: 'Karla'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#9c2d2f'
		},
		secondary: {
			main: '#EDE7C2'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#9c2d2f'
		}
	},
	pixels: {
		bRadius: {
			main: '10px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const funSourceTheme = createTheme({
	typography: {
		fontFamily: ['Oleo Script', 'Karla'].join(','),
		h1: {
			fontFamily: 'Oleo Script'
		},
		h2: {
			fontFamily: 'Oleo Script'
		},
		h3: {
			fontFamily: 'Karla'
		},
		h4: {
			fontFamily: 'Karla'
		},
		h5: {
			fontFamily: 'Karla'
		},
		h6: {
			fontFamily: 'Karla'
		},
		body1: {
			fontFamily: 'Karla'
		},
		body2: {
			fontFamily: 'Karla'
		},
		subtitle1: {
			fontFamily: 'Karla'
		},
		subtitle2: {
			fontFamily: 'Karla'
		},
		overline: {
			fontFamily: 'Karla'
		},
		caption: {
			fontFamily: 'Karla'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#9c2d2f'
		},
		secondary: {
			main: '#EDE7C2'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#9c2d2f'
		}
	},
	pixels: {
		bRadius: {
			main: '10px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const valueAccessTheme = createTheme({
	typography: {
		fontFamily: ['Source Serif 4', 'Libre Baskerville'].join(','),
		h1: {
			fontFamily: 'Source Serif 4'
		},
		h2: {
			fontFamily: 'Source Serif 4'
		},
		h3: {
			fontFamily: 'Source Serif 4'
		},
		h4: {
			fontFamily: 'Source Serif 4'
		},
		h5: {
			fontFamily: 'Source Serif 4'
		},
		h6: {
			fontFamily: 'Source Serif 4'
		},
		body1: {
			fontFamily: 'Libre Baskerville'
		},
		body2: {
			fontFamily: 'Libre Baskerville'
		},
		subtitle1: {
			fontFamily: 'Libre Baskerville'
		},
		subtitle2: {
			fontFamily: 'Libre Baskerville'
		},
		overline: {
			fontFamily: 'Libre Baskerville'
		},
		caption: {
			fontFamily: 'Libre Baskerville'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#325D42'
		},
		secondary: {
			main: '#F8E3B5'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#652e0f'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const essentialsForHomeTheme = createTheme({
	typography: {
		fontFamily: ['Overpass', 'Inter'].join(','),
		h1: {
			fontFamily: 'Overpass'
		},
		h2: {
			fontFamily: 'Overpass'
		},
		h3: {
			fontFamily: 'Overpass'
		},
		h4: {
			fontFamily: 'Overpass'
		},
		h5: {
			fontFamily: 'Overpass'
		},
		h6: {
			fontFamily: 'Overpass'
		},
		body1: {
			fontFamily: 'Inter'
		},
		body2: {
			fontFamily: 'Inter'
		},
		subtitle1: {
			fontFamily: 'Inter'
		},
		subtitle2: {
			fontFamily: 'Inter'
		},
		overline: {
			fontFamily: 'Inter'
		},
		caption: {
			fontFamily: 'Inter'
		}
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#3E3F3F'
		},
		secondary: {
			main: '#EBEAE9'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#615e5c'
		}
	},
	pixels: {
		bRadius: {
			main: '0px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const rizzbatesTheme = createTheme({
	typography: {
		fontFamily: 'Outfit'
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#000000'
		},
		secondary: {
			main: '#7265ad'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#7265ADFF'
		}
	},
	pixels: {
		bRadius: {
			main: '0px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const pulseTheme = createTheme({
	typography: {
		fontFamily: 'Red Hat Display'
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#e7c7db'
		},
		secondary: {
			main: '#BCB7AB'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#4a4848'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

const budgetSourceTheme = createTheme({
	typography: {
		fontFamily: 'Montserrat'
	},
	palette: {
		type: 'light',
		common: {
			black: '#000',
			white: '#fff',
			offWhite: '#B0B0B0',
			lightWhite: '#f4f4f4'
		},
		primary: {
			main: '#FFE32F'
		},
		secondary: {
			main: '#606060'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		heroBg: {
			main: '#006a16'
		}
	},
	pixels: {
		bRadius: {
			main: '25px'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
});

export {
	giftCardConnectionTheme,
	valuePlusTheme,
	savingsCentralTheme,
	tasteForSavingsTheme,
	homePlayTheme,
	funSourceTheme,
	valueAccessTheme,
	essentialsForHomeTheme,
	rizzbatesTheme,
	pulseTheme,
	budgetSourceTheme
};
